<template>
    <Modal v-show="visible" v-on:close="closeModal" v-on:confirm="confirmModal"
           :confirmText="'Un' + title.toLowerCase()" :title="'Un' + title.toLowerCase()">
        <template v-slot:body>
            <div class="input-group">
                <label for="reason">Begrundelse for un{{title.toLowerCase()}}</label>
                <input v-model="reason" type="text" id="reason" :class="{ininput: unbanAsFvForum && !plainUnban}" :disabled="deleteFromDatabase || plainUnban">
                <span class="ininput" v-show="unbanAsFvForum && !plainUnban">//Un{{titled.toLowerCase()}} - </span>
            </div>
            <div class="input-group checkbox" v-if="$api.getUser().hasPermission(['bansite.unban.*','bansite.unban.delete'])">
                <input v-model="deleteFromDatabase" type="checkbox" id="deleteFromDatabase" :disabled="unbanAsFvForum || plainUnban">
                <label for="deleteFromDatabase">Slet ban permanent fra databasen</label>
            </div>
            <div class="input-group checkbox" v-if="$api.getUser().hasPermission(['bansite.unban.*','bansite.unban.fvforum'])">
                <input v-model="unbanAsFvForum" type="checkbox" id="unbanAsFvForum" :disabled="deleteFromDatabase" @change="changeUnbanAsFvForum">
                <label for="unbanAsFvForum">Un{{title.toLowerCase()}} som FvForum</label>
            </div>
            <div class="input-group checkbox" v-if="$api.getUser().hasPermission(['bansite.unban.*','bansite.unban.noreason'])">
                <input v-model="plainUnban" type="checkbox" id="plainUnban" :disabled="deleteFromDatabase" @change="changeUnbanAsFvForum">
                <label for="plainUnban">Un{{title.toLowerCase()}} uden begrundelse</label>
            </div>
        </template>
        <template v-slot:footer>
            <button
                    type="button"
                    class="btn btn-primary"
                    @click="confirmModal"
                    :disabled="!(deleteFromDatabase || unbanAsFvForum || plainUnban || reason.length > 0)">
                Un{{title.toLowerCase()}} Spiller
            </button>
            <button
                    type="button"
                    class="btn btn-cancel"
                    @click="closeModal">
                Annuller
            </button>
        </template>
    </Modal>
</template>

<script>
    import Modal from './Modal'

    export default {
        components: {
            Modal
        },
        data() {
            return {
                reason: "",
                deleteFromDatabase: false,
                unbanAsFvForum: false,
                plainUnban: false
            }
        },
        computed: {
            ownUuid(){
                return this.$api.getUser().user.uuid;
            },
            title() {
                let name = this.$utils.getPageType(this.$route.name).type;
                return name.substring(0, 1).toUpperCase() + name.substring(1);
            },
            titled() {
                switch (this.type) {
                    case "kick":
                        return "Kicked";
                    case "ban":
                        return "Banned";
                    case "mute":
                        return "Muted";
                    case "name":
                        return "Banned";
                    default:
                        return "Straffet";
                }
            },
            type() {
                return this.$utils.getPageType(this.$route.name).type;
            },
        },
        methods: {
            closeModal() {
                this.$emit('close');
                this.reason = "";
                this.deleteFromDatabase = false;
                this.unbanAsFvForum = false;
                this.plainUnban = false;

            },
            confirmModal() {
                this.$emit('confirm', this.data())
                this.reason = "";
                this.deleteFromDatabase = false;
                this.unbanAsFvForum = false;
                this.plainUnban = false;
            },
            data(){
                return {
                    reason: this.reason,
                    deleteFromDatabase: this.deleteFromDatabase,
                    unbanAsFvForum: this.unbanAsFvForum,
                    plainUnban: this.plainUnban
                };
            },
            changeUnbanAsFvForum(){
                if(this.plainUnban) {
                    return;
                }
                if(this.unbanAsFvForum && this.reason === ""){
                    this.reason = this.title + " Appeal";
                } else if(this.reason === this.title + ' Appeal') {
                    this.reason = "";
                }
            }
        },
        props: ['visible', 'punishment'],
    }
</script>

<style scoped lang="scss">
</style>